<template>
  <PopUp v-if="open">
    <template #default>
      <div>
        <div class="d-flex justify-content-between">
          <button @click.stop="save">Save Change</button>
          <div @click.stop="open=false;"  role="button"  class="d-flex" style="width: fit-content">X</div>
        </div>
        <select class="m-2" name="tz" id="tz" v-model="timezone">
          <option v-for="tz in timeZones" :value="tz" :key="tz">{{tz}}</option>
        </select>
        <div class="row mb-4" v-for="d in days" :key="d.day">
          <div class="col fw-bold fs-18">{{d.day}}</div>
          <div class="col">
            <div class="row">
              <div class="col">
                <span class="fw-bol">Open</span>
                <input class="ms-2" type="time" v-model="d.open">
              </div>
              <div class="col">
                <span class="fw-bol">Close</span>
                <input class="ms-2" type="time" v-model="d.close">
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </PopUp>
</template>

<script setup>
import { defineProps, watch, ref, onMounted, defineEmits } from 'vue'
import PopUp from "@/components/waffle/components/PopUp.vue";
  const props = defineProps(['s' , 't'])
  const emit = defineEmits(['update'])
  const days = ref([])
  const timezone = ref('')
  const open = ref(false)

const timeZones = [
  "America/New_York", // Eastern Time Zone
  "America/Chicago", // Central Time Zone
  "America/Denver", // Mountain Time Zone
  "America/Los_Angeles", // Pacific Time Zone
  "America/Anchorage", // Alaska Time Zone
  "America/Adak", // Hawaii-Aleutian Time Zone
  "Europe/London", // Greenwich Mean Time
  "Europe/Berlin", // Central European Time
  "Europe/Moscow", // Moscow Time
  "Australia/Sydney", // Australian Eastern Time Zone
  "Australia/Adelaide", // Australian Central Time Zone
  "Australia/Perth", // Australian Western Time Zone
  "Asia/Tokyo", // Japan Standard Time
  "Asia/Shanghai", // China Standard Time
  "Asia/Kolkata", // Indian Standard Time
  "Asia/Dubai", // Arabian Standard Time
  "Africa/Nairobi", // Eastern African Time
  "America/Sao_Paulo", // Brasília Time
  "Asia/Makassar" // Central Indonesian Time
];

//window.dispatchEvent(new CustomEvent('open-schedule')) ==> to open run this in the console

  onMounted(() => {
    window.addEventListener('open-schedule', () => {
      open.value = true
    })
  })

  watch(() => props.s , (s) => {
    if(!s){
      days.value = [
        { day: 'Monday', open: null, close: null },
        { day: 'Tuesday', open: null, close: null },
        { day: 'Wednesday',open: null, close: null },
        { day: 'Thursday', open: null, close: null },
        { day: 'Friday', open: null, close: null },
        { day:'Saturday', open: null, close: null },
        { day:'Sunday', open: null, close: null }
      ]
      timezone.value = 'America/New_York'
    }else{
      days.value = JSON.parse(JSON.stringify(s)).map(el => convertTimeFormat(el));
      timezone.value = props?.t;
    }
  }, {
    immediate:true,
    deep:true
  })

function convertTo12Hour(time24h) {
  const [hours, minutes] = time24h?.split(':') ?? [];

  let period = 'a.m.';
  let hours12 = parseInt(hours, 10);

  if (hours12 >= 12) {
    period = 'p.m.';
    hours12 -= 12;
  }

  if (hours12 === 0) {
    hours12 = 12;
  }

  return `${hours12}:${minutes} ${period}`;
}

function convertTo24Hour(time12h) {

  const [time, modifier] = time12h?.split(' ') ?? [];

  let [hours, minutes] = time?.split(':') ?? [];

  if (hours === '12') {
    hours = '00';
  }

  if (modifier?.toLowerCase() === 'p.m.') {
    hours = parseInt(hours, 10) + 12;
  }

  if(hours?.length ===1){
    hours = '0' + hours
  }

  return `${hours}:${minutes}`;
}

function convertTimeFormat(schedule) {
  const { day, open, close } = schedule;
  const newOpen = open ? convertTo24Hour(open):open;
  const newClose = close ? convertTo24Hour(close):close;

  return { day, open: newOpen, close: newClose };
}

function revertTimeFormat(schedule) {
  const { day, open, close } = schedule;
  const newOpen = open ? convertTo12Hour(open):open;
  const newClose = close ? convertTo12Hour(close):close;

  return { day, open: newOpen, close: newClose };
}

const save = () => {
    emit('update', {s: days.value.map(el => revertTimeFormat(el)), t:timezone.value})
    open.value = false;
}

</script>